import * as React from "react";
import {ISvgIconProps, SvgIcon} from "../../../basic-ui-components/icon/svg-icon/svg.icon";

export class PaymentsRedirectIcon extends React.Component<ISvgIconProps, {}> {
    render() {
        return (
            <SvgIcon {...this.props} viewBox="0 0 38 38">
                <g id="Group_42663" data-name="Group 42663" transform="translate(-790 -354)">
                    <rect id="Rectangle_2343" data-name="Rectangle 2343" width="38" height="38" transform="translate(-790 -354)" fill={"currentColor"} opacity="0"/>
                    <g id="export" transform="translate(793 357)">
                        <g id="Group_42662" data-name="Group 42662" transform="translate(0 0)">
                            <g id="Group_42661" data-name="Group 42661">
                                <path id="Path_3798" data-name="Path 3798" d="M227.422,2.188H233.2L220,15.395a1.094,1.094,0,1,0,1.544,1.55L234.746,3.739V9.512a1.094,1.094,0,1,0,2.188,0V1.1a1.1,1.1,0,0,0-1.1-1.1h-8.415a1.094,1.094,0,1,0,0,2.188Z" transform="translate(-205.722 0)" fill={"currentColor"}/>
                                <path id="Path_3799" data-name="Path 3799" d="M6.552,31.212h18.1a6.558,6.558,0,0,0,6.552-6.552V16.135a1.092,1.092,0,0,0-2.184,0v8.519a4.375,4.375,0,0,1-4.368,4.368H6.552a4.375,4.375,0,0,1-4.368-4.368V6.558A4.375,4.375,0,0,1,6.552,2.19H15A1.1,1.1,0,0,0,15,0H6.552A6.558,6.558,0,0,0,0,6.552v18.1A6.564,6.564,0,0,0,6.552,31.212Z" transform="translate(0 0)" fill={"currentColor"}/>
                            </g>
                        </g>
                    </g>
                </g>
            </SvgIcon>
        );
    }
}

